// extracted by mini-css-extract-plugin
export default {"secondaryHeading":"CreateUser_secondaryHeading__T1ctw"};